export const STR = {
  it: {
    nav: {
      ethic: "Etica Artigiana",
      pistachio: "Il Pistacchio",
      flavours: "I Gusti",
      shops: "I Negozi",
      contacts: "Contatti",
      findShop: "Trova Negozio",
      mobileFind: "Trova il negozio più vicino",
    },
    hero: {
      badge: "Gelateria artigianale · dal 1994",
      lines: ["Il gelato vero,", "mantecato fresco,", "ogni giorno."],
      sub: "Dal 1994 mantechiamo gelato artigianale con latte fresco lombardo e materie prime selezionate. Tre negozi a Cornaredo, Arese e Pero, una produzione interamente senza glutine, una sola ossessione: la qualità.",
      ctaStores: "Trova il tuo negozio",
      ctaEthic: "La nostra etica",
      cardOver: "Etica Artigiana",
      cardText: "100% senza glutine",
    },
    premio: {
      over: "Riconoscimenti",
      titleA: "Premio Speciale Gambero Rosso: ",
      titleEm: "miglior gelato al cioccolato.",
      text: "E l'inserimento nella guida Gelaterie d'Italia del Gambero Rosso. Un riconoscimento che ci riempie d'orgoglio — e di responsabilità, ogni mattina.",
    },
    manifesto: {
      over: "Il nostro manifesto",
      title: "Etica Artigiana: quattro capitoli, una promessa.",
    },
    gusti: {
      over: "Menu vetrina",
      title: "I gusti del banco.",
      sub: "Una selezione che ruota con le stagioni. Ogni gusto è prodotto nel nostro laboratorio, interamente senza glutine.",
      gluten: "Tutti i gusti del banco sono senza glutine.",
      book: "Libro ingredienti e allergeni",
    },
    cinema: {
      over: "Direttamente dal banco",
      title: "Ogni giorno, da zero.",
      sub: "Il gelato che vedi in vetrina stamattina non esisteva. Lo mantechiamo fresco ogni giorno, in un laboratorio interamente senza glutine.",
      cap1: "Il banco, ogni mattina",
      cap2: "Frutta vera, colori veri",
    },
    stores: {
      over: "Vieni a trovarci",
      title: "I nostri tre negozi.",
      sub: "Orari, telefono, mappa e consegna a domicilio: scegli il punto vendita più vicino a te.",
      open: "Aperto ora",
      closed: "Chiuso",
      closedDay: "Lunedì chiuso",
      directions: "Indicazioni",
      orderOn: "Ordina su",
      noDelivery: "Solo in negozio, per ora",
    },
    news: {
      over: "Novità & Eventi",
      title: "Dai nostri negozi.",
      follow: "Le novità, ogni giorno, nelle nostre storie Instagram.",
      followCta: "Seguici su Instagram",
      more: "Scopri di più",
    },
    footer: {
      tagline: "Etica Artigiana dal 1994. Gelato artigianale con produzione 100% senza glutine, in rete con l'Associazione Italiana Celiachia.",
      shops: "I negozi",
      contacts: "Contatti",
      hoursA: "Arese 10:00 – 22:00",
      hoursB: "Cornaredo e Pero 11:00 – 22:00",
      closedMon: "Lunedì chiuso",
      delivery: "Consegna a domicilio: Glovo per Arese, Deliveroo per Cornaredo e Pero.",
      book: "Libro degli ingredienti e allergeni",
    },
    error: "Qualcosa non ha funzionato.",
    retry: "Riprova",
  },
  en: {
    nav: {
      ethic: "Our Ethics",
      pistachio: "The Pistachio",
      flavours: "Flavours",
      shops: "Shops",
      contacts: "Contacts",
      findShop: "Find a Shop",
      mobileFind: "Find the nearest shop",
    },
    hero: {
      badge: "Artisan gelateria · since 1994",
      lines: ["Real gelato,", "freshly churned,", "every day."],
      sub: "Since 1994 we have been churning artisan gelato with fresh Lombard milk and selected ingredients. Three shops in Cornaredo, Arese and Pero, an entirely gluten-free production, one single obsession: quality.",
      ctaStores: "Find your shop",
      ctaEthic: "Our ethics",
      cardOver: "Etica Artigiana",
      cardText: "100% gluten-free",
    },
    premio: {
      over: "Awards",
      titleA: "Gambero Rosso Special Award: ",
      titleEm: "best chocolate gelato.",
      text: "And a place in the Gambero Rosso guide Gelaterie d'Italia. An award that fills us with pride — and responsibility, every single morning.",
    },
    manifesto: {
      over: "Our manifesto",
      title: "Etica Artigiana: four chapters, one promise.",
    },
    gusti: {
      over: "Showcase menu",
      title: "The flavours on display.",
      sub: "A selection that rotates with the seasons. Every flavour is made in our workshop, entirely gluten-free.",
      gluten: "Every flavour on display is gluten-free.",
      book: "Ingredients & allergens book",
    },
    cinema: {
      over: "Straight from the counter",
      title: "Every day, from scratch.",
      sub: "The gelato you see in the display this morning did not exist. We churn it fresh every day, in an entirely gluten-free workshop.",
      cap1: "The counter, every morning",
      cap2: "Real fruit, real colours",
    },
    stores: {
      over: "Come visit us",
      title: "Our three shops.",
      sub: "Opening hours, phone, map and home delivery: choose the shop closest to you.",
      open: "Open now",
      closed: "Closed",
      closedDay: "Closed on Mondays",
      directions: "Directions",
      orderOn: "Order on",
      noDelivery: "In-store only, for now",
    },
    news: {
      over: "News & Events",
      title: "From our shops.",
      follow: "The daily news, in our Instagram stories.",
      followCta: "Follow us on Instagram",
      more: "Learn more",
    },
    footer: {
      tagline: "Etica Artigiana since 1994. Artisan gelato with 100% gluten-free production, within the network of the Italian Coeliac Association (AIC).",
      shops: "Shops",
      contacts: "Contacts",
      hoursA: "Arese 10:00 am – 10:00 pm",
      hoursB: "Cornaredo & Pero 11:00 am – 10:00 pm",
      closedMon: "Closed on Mondays",
      delivery: "Home delivery: Glovo for Arese, Deliveroo for Cornaredo and Pero.",
      book: "Ingredients & allergens book",
    },
    error: "Something went wrong.",
    retry: "Retry",
  },
};
